


















import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { CalendarData } from "../types";

@Component
export default class CancelModal extends Vue {
    @Prop() currentMeeting!: CalendarData | null;
    @Prop() translations: any;
    @Prop() hub!: any;
    @Prop() roomEmail!: string;
    @Prop() buttonStyle!: string;
    @Prop() buttonColor!: string;
    @Prop() subscriptionStarted!: boolean;

    isOpen = false;
    m = moment;

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }

    cancelMeeting() {
        if (this.currentMeeting && this.currentMeeting.Id) {
            this.close();
            if (!this.subscriptionStarted) return;
            this.$emit("setLoading", "cancel");

            this.hub.invoke("cancelAppointment", this.currentMeeting.Id, this.roomEmail).done((result: any) => {
                if (result) {
                    console.log("Cancelling meeting");
                    this.$emit("loadData");
                    this.$emit("setLoading", "");
                } else console.log("Failed to cancel meeting");
            });
        }
    }
}
